import { makeStyles } from '@fluentui/react-components';

export const useSelectOnlySwitchStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
